"use client"

import { useSyncExternalStore } from "react"

const subscribe = () => () => {}

/**
 * False during SSR and the first client render, true afterwards. Use to gate
 * rendering of persisted Zustand state so SSR markup matches the first paint.
 */
export function useHydrated() {
  return useSyncExternalStore(
    subscribe,
    () => true, // client snapshot
    () => false // server snapshot
  )
}
